<template>
  <div class="relate-div">
    <waterMark :num="5"></waterMark>
    <div class="drawer-salary-search relate-div">
      <div class="new-drawer-salary-cate mb10">选择行业，职能，职级可查询对应的薪酬</div>
      <div class="drawer-salary-form-item mb10">
        <div class="drawer-salary-form-label mr10"><span>*</span>行业</div>
        <el-select v-model="form.行业" size="mini" placeholder="请选择行业" @change="hangyeChange">
          <el-option label="公募基金" value="公募基金"></el-option>
          <el-option label="证券" value="证券"></el-option>
          <el-option label="PE" value="PE"></el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <div class="drawer-salary-form-label mr10"><span>*</span>职能模块</div>
        <el-select v-model="form.职能模块" size="mini" placeholder="请选择职能模块" filterable @change="cateChange">
          <el-option v-for="(opt, k) in cateOpt" :key="k" :label="opt" :value="opt"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <!-- <div class="drawer-salary-form-label"></div> -->
        <div class="drawer-salary-form-label mr10" style="margin-left:40px">细分职能</div>
        <el-select v-model="form.细分职能" size="mini" placeholder="请选择细分职能" filterable>
          <el-option v-for="(opt, k) in xiOpt" :key="k" :label="opt" :value="opt"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <!-- <div class="drawer-salary-form-label"></div> -->
        <div class="drawer-salary-form-label mr10" style="margin-left:40px">擅长方向</div>
        <el-select v-model="form.擅长方向" size="mini" placeholder="请选择擅长方向" filterable>
          <el-option v-for="(opt, k) in shanOpt" :key="k" :label="opt" :value="opt"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10">
        <div class="drawer-salary-form-label mr10"><span> </span>职级</div>
        <el-select v-model="form.职级" size="mini" placeholder="请选择职级">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(opt, k) in zhijiOpt" :key="k" :label="opt" :value="k"> </el-option>
        </el-select>
      </div>
      <div class="drawer-salary-form-item mb10" style="flex-direction: row-reverse;">
        <el-button type="primary" size="mini" @click="search()">确定</el-button>
      </div>
    </div>
    <div class="drawer-salary-result relate-div">
      <div v-show="form.行业 && form.职能模块" class="drawer-salary-cate">
        {{ form.行业 }} {{ form.职能模块 }} {{ form.细分职能 ? `（${form.细分职能}）` : '' }}
      </div>
      <template v-for="(zhi, key) in zhijiOpt">
        <div v-if="result[key]" :key="key" class="drawer-salary-box">
          <div class="drawer-salary-title">{{ zhi }}</div>
          <div class="drawer-salary-content">
            <div class="drawer-salary-row" style="border:none">
              <div class="drawer-salary-col drawer-salary-dark">单位:万</div>
              <div class="drawer-salary-col" style="background:#eee;color:#444">年固薪</div>
              <div v-if="form.行业 != 'PE'" class="drawer-salary-col" style="background:#eee;color:#444">年奖金</div>
              <div class="drawer-salary-col" style="background:#eee;color:#444">总薪酬</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">市场平均</div>
              <div class="drawer-salary-col">{{ result[key].固薪平均 || '-' }}</div>
              <div v-if="form.行业 != 'PE'" class="drawer-salary-col">{{ result[key].奖金平均 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬平均 || '-' }}</div>
            </div>
            <template v-if="opend.includes(key)">
              <div class="drawer-salary-row">
                <div class="drawer-salary-col drawer-salary-dark">90分位</div>
                <div class="drawer-salary-col">{{ result[key].固薪90 || '-' }}</div>
                <div v-if="form.行业 != 'PE'" class="drawer-salary-col">{{ result[key].奖金90 || '-' }}</div>
                <div class="drawer-salary-col">{{ result[key].薪酬90 || '-' }}</div>
              </div>
              <div class="drawer-salary-row">
                <div class="drawer-salary-col drawer-salary-dark">75分位</div>
                <div class="drawer-salary-col">{{ result[key].固薪75 || '-' }}</div>
                <div v-if="form.行业 != 'PE'" class="drawer-salary-col">{{ result[key].奖金75 || '-' }}</div>
                <div class="drawer-salary-col">{{ result[key].薪酬75 || '-' }}</div>
              </div>
              <div class="drawer-salary-row">
                <div class="drawer-salary-col drawer-salary-dark">50分位</div>
                <div class="drawer-salary-col">{{ result[key].固薪50 || '-' }}</div>
                <div v-if="form.行业 != 'PE'" class="drawer-salary-col">{{ result[key].奖金50 || '-' }}</div>
                <div class="drawer-salary-col">{{ result[key].薪酬50 || '-' }}</div>
              </div>
              <div class="drawer-salary-row">
                <div class="drawer-salary-col drawer-salary-dark">25分位</div>
                <div class="drawer-salary-col">{{ result[key].固薪25 || '-' }}</div>
                <div v-if="form.行业 != 'PE'" class="drawer-salary-col">{{ result[key].奖金25 || '-' }}</div>
                <div class="drawer-salary-col">{{ result[key].薪酬25 || '-' }}</div>
              </div>
              <div class="drawer-salary-row">
                <div class="drawer-salary-col drawer-salary-dark">10分位</div>
                <div class="drawer-salary-col">{{ result[key].固薪10 || '-' }}</div>
                <div v-if="form.行业 != 'PE'" class="drawer-salary-col">{{ result[key].奖金10 || '-' }}</div>
                <div class="drawer-salary-col">{{ result[key].薪酬10 || '-' }}</div>
              </div>
              <div class="drawer-salary-more"><i class="el-icon-arrow-up" @click="fold(key)">收起</i></div>
            </template>
            <div v-else class="drawer-salary-more"><i class="el-icon-arrow-down" @click="expand(key)">更多</i></div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
// ./NewDrawer/searchBar/Industry 复制了此组件搜索部分（drawer-salary-search）的代码，如有调整，需要一并修改
export default {
  data() {
    return {
      form: {},
      cateData: [],
      cateOpt: [],
      xiOpt: [],
      shanOpt: [],
      zhijiOpt: [],
      zyzj: {
        MD: 'MD',
        ED: 'ED',
        D: 'D',
        AD: 'AD',
        VP: 'VP',
        A: 'A',
        AN: 'AN',
      },
      zj: {
        '1': '1.高管',
        '2': '2.部门总',
        '3': '3.部门副总/总助/团队长',
        '4': '4.部门核心骨干',
        '5': '5.新人三年以下',
      },
      opend: [],
      result: {},
    }
  },
  watch: {
    form:{
      handler(newValue, oldValue) {
        this.zhijiOpt = this.form.行业 == '证券' ? this.zyzj : this.zj
      },
      immediate:true,
      deep:true,
    },
  },
  async mounted() {
    await this.loadCate()
  },
  methods: {
    async loadCate() {
      if (!app.categories) {
        await app.getCats()
      }
      const cateData = app.categories
      if (cateData && cateData.length > 0) {
        this.cateData = cateData
        const tmp = cateData.map(item => item['名称'])
        this.cateOpt = JSON.parse(JSON.stringify(tmp))
      }
    },
    hangyeChange() {
      // this.zhijiOpt = this.form.行业 == '证券' ? this.zyzj : this.zj
    },
    cateChange() {
      if (this.form.职能模块) {
        const filtered = this.cateData.filter(c => c.名称 == this.form.职能模块)
        this.xiOpt = filtered[0].二级职能 || []
        this.shanOpt = filtered[0].擅长方向 || []
        delete this.form.细分职能
        delete this.form.擅长方向
      }
    },
    expand(key) {
      if (!this.opend.includes(key)) {
        this.opend.push(key)
      }
    },
    fold(key) {
      if (this.opend.includes(key)) {
        this.opend = this.opend.filter(o => o != key)
      }
    },
    async search(defaultForm) {
      if (defaultForm && typeof defaultForm === 'object') this.form = defaultForm
      const form = this.form
      if (!form.行业) return this.$message('请选择行业')
      if (!form.职能模块) return this.$message('请选择职能')
      const res = await app.service('radish').getHangyeSalary(form)
      if (res.status === 'success' && res.data) {
        this.result = res.data
        this.opend = [Object.keys(this.zhijiOpt).find(zhi => res.data[zhi])]
      } else {
        this.result = {}
        this.opend = []
        this.$message(res.msg)
      }
    },
  },
}
</script>
<style>
.drawer-salary-form-item {
  display: flex;
  margin-bottom: 5px;
}
.drawer-salary-form-item .el-select {
  width: 100%;
}
.drawer-salary-form-label,
.drawer-salary-form-label-big {
  line-height: 28px;
}
.drawer-salary-form-label {
  width: 80px;
}
.drawer-salary-form-label span {
  color: red;
  margin-right: 5px;
}
.drawer-salary-cate {
  padding: 3px 5px;
  background-color: #eee;
  border-radius: 5px;
  margin: 5px;
  text-align: center;
}
.drawer-salary-box {
  margin: 5px 0;
}
.drawer-salary-title {
  display: inline-block;
  padding: 3px 10px;
  background-color: #eee;
  border-radius: 5px 5px 0 0;
}
.drawer-salary-content {
  padding: 5px;
  border-radius: 0 5px 5px 5px;
  background-color: #eee;
}
.drawer-salary-row {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #aaa;
}
.drawer-salary-col {
  flex: 1;
  line-height: 24px;
  text-align: center;
  border-left: 1px solid #aaa;
  background-color: #fff;
}
.drawer-salary-dark {
  background-color: #eee;
  color: #444;
  border: none;
}
.drawer-salary-more {
  color: #409eff;
  cursor: pointer;
  text-align: right;
  padding: 5px 5px 0 0;
}
.new-drawer-salary-cate {
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}
</style>
